export default __webpack_public_path__ + "static/media/astrazeneca-logo-blanco.3d1af7b9.png";